<template>
    <!-- change -->
    <div class="inertia-tool">
        <div class="form__item">
            <label>
                <span>{{ $t('rthTool.labelSpan') }}</span>
                <a class="label-text--second-line pull-right" @click="$emit('toggle')">
                    {{ $t('rthTool.labelLink') }}
                </a>
            </label>
        </div>

        <div class="inertia-tool__abstraction">
            <div class="row" v-show="showSurfaceArea">
                <div class="col-12">
                    <div class="form__item">
                        <label>
                            {{
                                scenario.isTorque()
                                    ? $t('rthTool.houseSurfaceArea')
                                    : $t('rthTool.slideSurfaceArea')
                            }}
                        </label>
                        <input
                            type="text"
                            ref="rthermSurfaceArea"
                            v-model.lazy="scenario.applicationData.rthermSurfaceArea"
                            @blur="updateRthermSurfaceArea"
                            @change="computeRtherm"
                            class="form__input--text"
                        />
                    </div>
                </div>
            </div>

            <div class="row col-12">
                <label>{{ $t('rthTool.waterCooling') }}</label>
            </div>
            <div class="row inertia-tool__radio-group">
                <div class="offset-1 col-5 radio">
                    <input
                        class="radio__rb"
                        type="radio"
                        id="water_cooling_yes"
                        value="yes"
                        v-model.lazy="scenario.applicationData._rthermWaterCooling"
                        @change="computeRtherm"
                    />
                    <label class="radio__label" for="water_cooling_yes">
                        {{ $t('rthTool.yes') }}
                    </label>
                </div>
                <div class="offset-1 col-5 radio">
                    <input
                        class="radio__rb"
                        type="radio"
                        id="water_cooling_no"
                        value="no"
                        v-model.lazy="scenario.applicationData._rthermWaterCooling"
                        @change="computeRtherm"
                    />
                    <label class="radio__label" for="water_cooling_no">
                        {{ $t('rthTool.no') }}
                    </label>
                </div>
            </div>

            <div class="row" v-show="showFlow">
                <div class="col-12">
                    <div class="form__item">
                        <label>{{ $t('rthTool.flow') }}</label>
                        <input
                            type="text"
                            ref="rthermFlow"
                            v-model.lazy="scenario.applicationData.rthermFlow"
                            @blur="updateRthermFlow"
                            @change="computeRtherm"
                            class="form__input--text"
                        />
                    </div>
                </div>
            </div>

            <div class="row col-12" v-show="showMovingType">
                <label>{{ $t('rthTool.movingType') }}</label>
            </div>
            <div class="row inertia-tool__radio-group" v-show="showMovingType">
                <div class="offset-1 col-5 radio">
                    <input
                        class="radio__rb"
                        type="radio"
                        id="moving_coil"
                        value="moving_coil"
                        v-model.lazy="scenario.applicationData._rthermMovingType"
                        @change="computeRtherm"
                    />
                    <label class="radio__label" for="moving_coil">
                        {{ $t('rthTool.movingCoil') }}
                    </label>
                </div>
                <div class="offset-1 col-5 radio">
                    <input
                        class="radio__rb"
                        type="radio"
                        id="moving_magnet"
                        value="moving_magnet"
                        v-model.lazy="scenario.applicationData._rthermMovingType"
                        @change="computeRtherm"
                    />
                    <label class="radio__label" for="moving_magnet">
                        {{ $t('rthTool.movingMagnet') }}
                    </label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 form__item">
                <label>
                    <span>{{ $t('rthTool.resulting') }}</span>
                </label>
                <input
                    type="text"
                    ref="rtherm"
                    v-model.lazy="scenario.applicationData.rtherm_heatsink"
                    @blur="updateRthermHeatsink"
                    class="form__input--text"
                    disabled
                />
            </div>

            <div class="col-sm-6">
                <a class="button--secondary" style="margin-top: 3.2rem;" @click="$emit('toggle')">
                    {{ $t('rthTool.buttonToggle') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class RthTool extends Vue {
    @Prop() scenario;

    created() {
        // Trigger defaults
        if (!this.scenario.applicationData._rthermMovingType) {
            this.scenario.applicationData._rthermMovingType = 'moving_coil';
        }
        if (!this.scenario.applicationData._rthermWaterCooling) {
            this.scenario.applicationData._rthermWaterCooling = 'no';
        }
        if (this.scenario.motor.length) {
            this.scenario.applicationData.rthermMotorLength = this.scenario.motor.length;
        }
        if (this.scenario.motor.width) {
            this.scenario.applicationData.rthermMotorWidth = this.scenario.motor.width;
        }
    }

    mounted() {
        this.computeRtherm();
    }

    /**
     * Set the updated value as soon as an input blurs to reflect the unit
     * @param field
     */
    onInputBlur(field, value) {
        if (field !== undefined) {
            field.value = value;
        }
    }

    updateRthermHeatsink() {
        this.onInputBlur(this.$refs.rtherm, this.scenario.applicationData.rtherm_heatsink);
    }

    updateRthermSurfaceArea() {
        this.onInputBlur(
            this.$refs.rthermSurfaceArea,
            this.scenario.applicationData.rthermSurfaceArea,
        );
    }

    updateRthermMotorLength() {
        this.onInputBlur(
            this.$refs.rthermMotorLength,
            this.scenario.applicationData.rthermMotorLength,
        );
    }

    updateRthermMotorWidth() {
        this.onInputBlur(
            this.$refs.rthermMotorWidth,
            this.scenario.applicationData.rthermMotorWidth,
        );
    }

    updateRthermFlow() {
        this.onInputBlur(this.$refs.rthermFlow, this.scenario.applicationData.rthermFlow);
    }

    computeRtherm() {
        this.scenario.applicationData.recomputeRthermHeatsink();
        this.updateRthermHeatsink();
    }

    /* getters for dynamic inputs */

    get showSurfaceArea() {
        return (
            this.scenario.isTorque() || this.scenario.applicationData._rthermWaterCooling === 'no'
        );
    }

    get showFlow() {
        return this.scenario.applicationData._rthermWaterCooling === 'yes';
    }

    get showMovingType() {
        return (
            !this.scenario.isTorque() && this.scenario.applicationData._rthermWaterCooling === 'no'
        );
    }
}
</script>
